<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('network.fields.companyName')"
      required
      :value="value.companyName"
      :error="findError('companyName')"
      :disabled="disabled"
      @input="propertyChange('companyName', $event)"
    />

    <template v-if="!isNew">
      <string-form-field
        :label="$t('network.fields.urlCode')"
        :value="value.urlCode"
        disabled
      />

      <b-row class="mb-4">
        <div class="col">
          <b-button
            block
            variant="success"
            :to="{
              name: 'ProviderRegistrationRequest',
              query: { n: value.urlCode }
            }"
            target="_blank"
          >
            Invita fornitore
          </b-button>
        </div>
        <div class="col">
          <b-button
            block
            variant="success"
            :to="{ name: 'Home', query: { n: value.urlCode } }"
            target="_blank"
          >
            Invita cliente
          </b-button>
        </div>
      </b-row>
    </template>

    <b-row>
      <string-form-field
        :label="$t('network.fields.fiscalCode')"
        required
        :value="value.fiscalCode"
        :error="findError('fiscalCode')"
        :disabled="disabled"
        class="col-md-6"
        @input="propertyChange('fiscalCode', $event)"
      />
      <string-form-field
        :label="$t('network.fields.vatNumber')"
        required
        :value="value.vatNumber"
        :error="findError('vatNumber')"
        :disabled="disabled"
        class="col-md-6"
        @input="propertyChange('vatNumber', $event)"
      />
    </b-row>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  props: {
    isNew: {
      type: Boolean,
      required: true
    }
  }
};
</script>
